export const TOUR_GAMES_FLAG = process.env.REACT_APP_TOUR_GAMES_FLAG;
// export const TEST_TOUR_GAMES_ID = 'Summer2021';
export const TEST_TOUR_GAMES_ID = 'SpringTour2024';
export const ROLES = {
  ADMIN: 'admin',
  MOD: 'moderator',
  TG_BETA: 'tgBeta'
};
